/* RHL product-aware quote requests. No Admin API credentials are used in the storefront. */
(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else if (!root.RHLQuoteContext) {
    root.RHLQuoteContext = api;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { api.init(root); });
    else api.init(root);
  }
})(typeof window !== 'undefined' ? window : globalThis, function () {
  'use strict';
  var PREFIX = 'rhl-quote:v1:';
  var PARAMS = ['rhl_product', 'rhl_variant', 'rhl_options', 'rhl_option_values', 'rhl_quantity', 'rhl_quote', 'rhl_title', 'rhl_image'];
  function str(v, max) { return String(v == null ? '' : v).slice(0, max || 500); }
  function id(v) { return /^\d{1,20}$/.test(String(v)) ? String(v) : ''; }
  function quantity(v) { var n = Number(v); return Number.isInteger(n) && n >= 1 && n <= 9999 ? n : 1; }
  function parse(v) { try { return JSON.parse(v); } catch (_) { return null; } }
  function options(v) {
    return Array.isArray(v) ? v.slice(0, 3).map(function (o) {
      return { name: str(o && o.name, 100), value: str(o && o.value, 250), id: id(o && o.id) };
    }).filter(function (o) { return o.name; }) : [];
  }
  function matchOptions(values, selected) {
    return Array.isArray(values) && values.length === selected.length && selected.every(function (o, i) { return o.value && o.value === String(values[i]); });
  }
  function imageUrl(value, origin) {
    if (!value) return '';
    try {
      var u = new URL(value, origin);
      return u.protocol === 'https:' && (u.origin === origin || u.hostname === 'cdn.shopify.com' || u.hostname.endsWith('.shopifycdn.com')) ? u.href : '';
    } catch (_) { return ''; }
  }
  function productUrl(handle, selection, origin, shopRoot) {
    if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle || '')) return '';
    var u = new URL((shopRoot || '/') + 'products/' + handle, origin);
    if (selection.optionIds) u.searchParams.set('option_values', selection.optionIds);
    else if (id(selection.variantId)) u.searchParams.set('variant', selection.variantId);
    return u.href;
  }
  function readSelection(data, scope) {
    var picker = scope.querySelector('hdt-variant-picker');
    var selected = [];
    if (picker && !data.hasOnlyDefaultVariant) {
      Array.from(picker.querySelectorAll('fieldset[data-index]')).sort(function (a, b) { return Number(a.dataset.index) - Number(b.dataset.index); }).forEach(function (field) {
        var index = Number(field.dataset.index);
        var input = field.querySelector('input[is-value]:checked');
        var chosen = field.querySelector('[role="option"][aria-selected="true"]');
        var hidden = field.querySelector('input[is-value][type="hidden"]');
        var el = input || chosen;
        selected.push({ name: str(data.optionNames[index], 100), value: str(el ? (el.value || el.getAttribute('value')) : hidden ? hidden.value : '', 250), id: id(el && el.getAttribute('data-value-id')) });
      });
    }
    var currentScript = picker && picker.querySelector('script[id^="selected-variant-"]');
    var current = currentScript && parse(currentScript.textContent);
    if (!current || typeof current !== 'object') current = data.variant;
    // Selected controls outrank a stale JSON node while the theme fetches the next variant.
    var matches = data.hasOnlyDefaultVariant || matchOptions(current && current.options, selected);
    var variantId = matches ? id(current && current.id) : '';
    var allOptionIds = selected.length && selected.length === data.optionNames.length && selected.every(function (o) { return o.id && o.value; });
    var image = matches && current && current.featured_image && current.featured_image.src;
    image = image || (matches && current && current.featured_media && current.featured_media.preview_image && current.featured_media.preview_image.src);
    var sameInitial = variantId && data.variant && variantId === String(data.variant.id);
    var qty = scope.querySelector('input[name="quantity"]');
    return {
      handle: data.handle, title: data.title, image: image || (sameInitial ? data.image : data.productImage),
      variantId: variantId, sku: matches ? str(current && current.sku, 100) : '',
      options: selected, optionIds: allOptionIds ? selected.map(function (o) { return o.id; }).join(',') : '',
      quantity: quantity(qty && qty.value), hasOnlyDefaultVariant: Boolean(data.hasOnlyDefaultVariant), createdAt: Date.now()
    };
  }
  function quoteUrl(base, selection, origin, token) {
    var u = new URL(base, origin);
    PARAMS.forEach(function (p) { u.searchParams.delete(p); });
    u.searchParams.set('rhl_product', selection.handle);
    if (selection.title) u.searchParams.set('rhl_title', str(selection.title, 500));
    var image = imageUrl(selection.image, origin);
    if (image) u.searchParams.set('rhl_image', image);
    if (selection.variantId) u.searchParams.set('rhl_variant', selection.variantId);
    if (selection.options.length) u.searchParams.set('rhl_options', JSON.stringify(selection.options));
    if (selection.optionIds) u.searchParams.set('rhl_option_values', selection.optionIds);
    u.searchParams.set('rhl_quantity', quantity(selection.quantity));
    u.searchParams.set('rhl_quote', token);
    u.hash = 'rhl-quote-form';
    return u.href;
  }
  function readRequest(url) {
    var p = new URL(url).searchParams;
    var handle = p.get('rhl_product') || '';
    if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)) return null;
    var selected = options(parse(p.get('rhl_options')));
    var ids = str(p.get('rhl_option_values'), 80);
    if (!/^\d{1,20}(,\d{1,20}){0,2}$/.test(ids)) ids = '';
    return { handle: handle, title: str(p.get('rhl_title'), 500), image: imageUrl(p.get('rhl_image'), new URL(url).origin), variantId: id(p.get('rhl_variant')), options: selected, optionIds: ids, quantity: quantity(p.get('rhl_quantity')), token: str(p.get('rhl_quote'), 80) };
  }
  function normalizeCart(cart, origin) {
    if (!cart || !Array.isArray(cart.items) || cart.items.length > 100) return null;
    var items = cart.items.map(function (item) {
      var handle = str(item && item.handle, 255);
      if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle) && item && item.url) {
        try {
          var itemUrl = new URL(item.url, origin);
          var match = itemUrl.origin === origin && itemUrl.pathname.match(/(?:^|\/)products\/([a-z0-9][a-z0-9-]{0,254})(?:\/|$)/);
          if (match) handle = match[1];
        } catch (_) { /* Ignore an invalid cart product URL. */ }
      }
      if (!/^[a-z0-9][a-z0-9-]{0,254}$/.test(handle)) return null;
      var selected = options(item.options_with_values);
      if (!selected.length && Array.isArray(item.variant_options)) {
        selected = item.variant_options.slice(0, 3).map(function (value, index) {
          return { name: 'Option ' + (index + 1), value: str(value, 250), id: '' };
        }).filter(function (option) { return option.value && option.value !== 'Default Title'; });
      }
      var properties = [];
      if (item.properties && typeof item.properties === 'object') {
        Object.keys(item.properties).slice(0, 20).forEach(function (name) {
          var value = item.properties[name];
          if (name.charAt(0) !== '_' && value != null && String(value).trim()) properties.push({ name: str(name, 100), value: str(value, 500) });
        });
      }
      var featured = item.featured_image && item.featured_image.url;
      return {
        handle: handle, title: str(item.product_title || item.title || handle.replace(/-/g, ' '), 500),
        image: imageUrl(featured || item.image || '', origin), variantId: id(item.variant_id || item.id),
        sku: str(item.sku, 100), variantTitle: str(item.variant_title, 250),
        options: selected, quantity: quantity(item.quantity), properties: properties,
        sellingPlan: str(item.selling_plan_allocation && item.selling_plan_allocation.selling_plan && item.selling_plan_allocation.selling_plan.name, 250)
      };
    }).filter(Boolean);
    if (!items.length) return null;
    return { items: items, note: str(cart.note, 2000) };
  }
  function readCartSnapshot(win, token) {
    if (!/^[a-z0-9-]{8,80}$/i.test(token || '')) return null;
    try {
      var stored = normalizeCart(parse(win.sessionStorage.getItem(PREFIX + 'cart:' + token)), win.location.origin);
      if (stored) return stored;
    } catch (_) { /* Embedded previews can block sessionStorage. */ }
    try {
      var transfer = parse(win.name);
      if (transfer && transfer.kind === 'rhl-cart-quote-v1' && transfer.token === token && transfer.cart) {
        win.name = typeof transfer.previousName === 'string' ? transfer.previousName : '';
        return normalizeCart(transfer.cart, win.location.origin);
      }
    } catch (_) { /* The URL still opens; never block the enquiry form. */ }
    return null;
  }
  function renderCartSnapshot(win, form, basket, snapshot) {
    var doc = win.document;
    var legend = basket.querySelector('legend') || doc.createElement('legend');
    if (!legend.textContent) legend.textContent = 'Selected products';
    basket.replaceChildren(legend);
    var root = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
    var total = snapshot.items.reduce(function (sum, item) { return sum + item.quantity; }, 0);
    var head = doc.createElement('div'); head.className = 'rhl-q-cart__head';
    var count = doc.createElement('p');
    count.textContent = snapshot.items.length + (snapshot.items.length === 1 ? ' selection · ' : ' selections · ') + total + (total === 1 ? ' item' : ' items');
    var edit = doc.createElement('a'); edit.href = new URL(root + 'cart', win.location.origin).href; edit.textContent = 'Edit products & quantities';
    edit.setAttribute('data-no-instant', ''); head.append(count, edit); basket.appendChild(head);
    var more = null;
    snapshot.items.forEach(function (item, index) {
      if (index === 2) {
        more = doc.createElement('details'); more.className = 'rhl-q-cart__more';
        var summary = doc.createElement('summary'); summary.textContent = 'More products (' + (snapshot.items.length - 2) + ') — all included in your enquiry';
        more.appendChild(summary); basket.appendChild(more);
      }
      var parent = index < 2 || !more ? basket : more;
      var card = doc.createElement('article'); card.className = 'rhl-q-product rhl-q-cart__item';
      var src = imageUrl(item.image, win.location.origin);
      if (src) { var image = doc.createElement('img'); image.className = 'rhl-q-product__image'; image.src = src; image.width = 116; image.height = 116; image.loading = 'lazy'; image.alt = item.title; card.appendChild(image); }
      var content = doc.createElement('div'); content.className = 'rhl-q-product__content';
      var eyebrow = doc.createElement('p'); eyebrow.className = 'rhl-q-product__eyebrow'; eyebrow.textContent = 'Selected product ' + (index + 1);
      var title = doc.createElement('strong'); title.className = 'rhl-q-product__title'; title.textContent = item.title;
      var productLink = doc.createElement('a'); productLink.className = 'rhl-q-product__link';
      var productHref = new URL(root + 'products/' + item.handle, win.location.origin);
      if (item.variantId) productHref.searchParams.set('variant', item.variantId);
      productLink.href = productHref.href; productLink.textContent = 'View product';
      var dl = doc.createElement('dl'); dl.className = 'rhl-q-product__options';
      function pair(name, value) { var dt = doc.createElement('dt'); dt.textContent = name; var dd = doc.createElement('dd'); dd.textContent = value; dl.append(dt, dd); }
      item.options.forEach(function (option) { pair(option.name, option.value || 'Please confirm'); });
      if (item.variantTitle && item.variantTitle !== 'Default Title' && !item.options.length) pair('Variant', item.variantTitle);
      if (item.sku) pair('SKU', item.sku);
      pair('Quantity', String(item.quantity));
      item.properties.forEach(function (property) { pair(property.name, property.value); });
      if (item.sellingPlan) pair('Plan', item.sellingPlan);
      content.append(eyebrow, title, productLink, dl); card.append(content); parent.appendChild(card);
      var details = [
        'Product: ' + item.title, 'Product URL: ' + productHref.href, 'Product image: ' + src,
        'Variant ID: ' + item.variantId, 'SKU: ' + item.sku, 'Quantity: ' + item.quantity
      ];
      item.options.forEach(function (option) { details.push(option.name + ': ' + option.value); });
      item.properties.forEach(function (property) { details.push(property.name + ': ' + property.value); });
      if (item.sellingPlan) details.push('Plan: ' + item.sellingPlan);
      var serialized = doc.createElement('textarea'); serialized.hidden = true; serialized.name = 'contact[Product ' + (index + 1) + ']';
      serialized.setAttribute('data-quote-cart-field', ''); serialized.value = details.join('\n'); card.appendChild(serialized);
    });
    function hidden(name, value) { var input = doc.createElement('input'); input.type = 'hidden'; input.name = name; input.value = value; basket.appendChild(input); }
    hidden('contact[Number of selections]', String(snapshot.items.length));
    hidden('contact[Total quantity]', String(total));
    if (snapshot.note) { var note = doc.createElement('textarea'); note.hidden = true; note.name = 'contact[Basket notes]'; note.value = snapshot.note; basket.appendChild(note); }
    var hint = doc.createElement('p'); hint.className = 'rhl-q-hint'; hint.textContent = 'Every product shown here, including collapsed products, will be included with your request.';
    basket.appendChild(hint);
  }
  function enrich(request, data) {
    if (!data || data.handle !== request.handle || typeof data.title !== 'string') throw new Error('Invalid product response');
    var selected = request.options;
    var matched = !selected.length || matchOptions(data.variant && data.variant.options, selected);
    if (request.variantId && !request.optionIds && String(data.variant && data.variant.id) !== request.variantId) matched = false;
    var canonical = data.hasOnlyDefaultVariant ? [] : (data.optionNames || []).map(function (name, index) {
      return { name: str(name, 100), value: str(data.variant && data.variant.options[index], 250), id: '' };
    });
    return Object.assign({}, request, {
      title: data.title, image: matched ? data.image : data.productImage,
      variantId: matched ? id(data.variant && data.variant.id) : '', sku: matched ? str(data.variant && data.variant.sku, 100) : '',
      options: matched ? canonical : selected, needsConfirmation: !matched || !data.variant,
      hasOnlyDefaultVariant: Boolean(data.hasOnlyDefaultVariant)
    });
  }
  function initProduct(win, node) {
    if (node.dataset.quoteReady) return;
    node.dataset.quoteReady = 'true';
    var data = parse(node.textContent);
    if (!data || !data.handle) return;
    var doc = win.document;
    var scope = doc.getElementById('shopify-section-' + node.dataset.sectionId);
    if (!scope) return;
    var basePath = ((win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/') + 'pages/contact';
    var token = win.crypto && win.crypto.randomUUID ? win.crypto.randomUUID() : Date.now().toString(36) + Math.random().toString(36).slice(2);
    function isQuoteLink(a) {
      if (!a || !a.matches('a.hdt-block-button__custom')) return false;
      try { var u = new URL(a.href, win.location.origin); return u.origin === win.location.origin && /\/pages\/contact\/?$/.test(u.pathname) && /quote/i.test(a.textContent); } catch (_) { return false; }
    }
    function update(a) {
      if (!isQuoteLink(a)) return;
      var selection = readSelection(data, scope);
      a.href = quoteUrl(basePath, selection, win.location.origin, token);
      try { win.sessionStorage.setItem(PREFIX + token, JSON.stringify(selection)); } catch (_) { /* URL context remains usable without storage. */ }
    }
    function updateAll() { scope.querySelectorAll('a.hdt-block-button__custom').forEach(update); }
    scope.addEventListener('change', updateAll);
    scope.addEventListener('input', function (e) { if (e.target.name === 'quantity') updateAll(); });
    ['pointerdown', 'click', 'auxclick', 'contextmenu'].forEach(function (name) {
      scope.addEventListener(name, function (e) { var a = e.target.closest && e.target.closest('a'); update(a); }, true);
    });
    // Dropdown controls commit their value during the theme click handler.
    scope.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('hdt-variant-picker')) win.setTimeout(updateAll, 0);
    });
    updateAll();
  }
  function initForm(win, form) {
    if (form.dataset.quoteReady) return;
    form.dataset.quoteReady = 'true';
    if (new URL(win.location.href).searchParams.get('rhl_cart') === '1') {
      var basket = form.querySelector('[data-quote-cart]');
      if (basket) {
        basket.hidden = false;
        basket.disabled = false;
        var cartToken = new URL(win.location.href).searchParams.get('rhl_cart_quote');
        var cartSnapshot = readCartSnapshot(win, cartToken);
        if (cartSnapshot) renderCartSnapshot(win, form, basket, cartSnapshot);
        var basketQuantity = form.querySelector('#q-quantity');
        if (basketQuantity) {
          basketQuantity.disabled = true;
          basketQuantity.closest('.rhl-q-f').hidden = true;
        }
        // Preserve basket mode through Shopify's validation/success return.
        var returnTo = win.document.createElement('input');
        returnTo.type = 'hidden';
        returnTo.name = 'return_to';
        returnTo.value = win.location.pathname + win.location.search + '#rhl-quote-form';
        form.appendChild(returnTo);
        var action = new URL(form.action, win.location.origin);
        action.searchParams.set('rhl_cart', '1');
        form.action = action.href;
        initUpload(win, form);
        return;
      }
    }
    var doc = win.document;
    var request = readRequest(win.location.href);
    var shopRoot = (win.Shopify && win.Shopify.routes && win.Shopify.routes.root) || '/';
    var card = form.querySelector('[data-quote-product]');
    var message = form.querySelector('[data-quote-context-message]');
    var current = request;
    var cleared = false;
    var controller;
    function field(key, value) {
      var el = form.querySelector('#' + key);
      if (el) { el.value = str(value, 4000); el.disabled = !value; }
    }
    function render(selection, status) {
      current = selection;
      if (!selection || !card) return;
      card.hidden = false;
      var title = form.querySelector('[data-quote-title]');
      if (title) title.textContent = selection.title || selection.handle.replace(/-/g, ' ');
      var url = productUrl(selection.handle, selection, win.location.origin, shopRoot);
      var link = form.querySelector('[data-quote-product-link]');
      if (link) { link.href = url; link.hidden = !url; }
      var image = form.querySelector('[data-quote-image]');
      var src = imageUrl(selection.image || '', win.location.origin);
      if (image) { image.hidden = !src; if (src) { image.src = src; image.alt = selection.title || 'Selected product'; } else image.removeAttribute('src'); }
      var list = form.querySelector('[data-quote-options]');
      if (list) {
        list.replaceChildren();
        (selection.options || []).forEach(function (o) {
          var dt = doc.createElement('dt'); dt.textContent = o.name;
          var dd = doc.createElement('dd'); dd.textContent = o.value || 'Please confirm';
          list.append(dt, dd);
        });
      }
      var statusEl = form.querySelector('[data-quote-status]');
      if (statusEl) statusEl.textContent = status || (selection.needsConfirmation ? 'Your requested combination will be confirmed by our team.' : 'This product and selection will be included with your request.');
      field('q-product-name', selection.title || selection.handle);
      field('q-product-url', url);
      field('q-product-image', src);
      field('q-variant-id', selection.variantId);
      field('q-variant-sku', selection.sku);
      var description = (selection.options || []).map(function (o) { return o.name + ': ' + (o.value || 'Not selected'); }).join('\n');
      field('q-selected-options', description || 'Standard configuration');
      field('q-context-summary', [selection.title || selection.handle, url, description, selection.needsConfirmation ? 'Requested combination: please confirm.' : ''].filter(Boolean).join('\n'));
    }
    var clear = form.querySelector('[data-quote-clear]');
    if (clear) clear.addEventListener('click', function () {
      cleared = true; current = null;
      if (controller) controller.abort();
      card.hidden = true;
      ['q-product-name', 'q-product-url', 'q-product-image', 'q-variant-id', 'q-variant-sku', 'q-selected-options', 'q-context-summary'].forEach(function (key) { field(key, ''); });
      if (message) { message.hidden = true; message.textContent = ''; }
      if (request) { try { win.sessionStorage.removeItem(PREFIX + request.token); } catch (_) {} }
      var url = new URL(win.location.href); PARAMS.forEach(function (p) { url.searchParams.delete(p); });
      win.history.replaceState(null, '', url.href);
    });
    if (request) {
      var cached;
      try { cached = parse(win.sessionStorage.getItem(PREFIX + request.token)); } catch (_) {}
      if (cached && cached.handle === request.handle && Date.now() - cached.createdAt < 2 * 60 * 60 * 1000) {
        // Only use cached details for exactly the request selection; never reuse another product/tab.
        if (cached.variantId === request.variantId && cached.optionIds === request.optionIds && JSON.stringify(cached.options) === JSON.stringify(request.options)) request = Object.assign({}, cached, request);
      }
      render(request, 'Checking your selected product…');
      var qty = form.querySelector('#q-quantity');
      if (qty) qty.value = request.quantity;
      var endpoint = new URL(productUrl(request.handle, request, win.location.origin, shopRoot));
      endpoint.searchParams.set('view', 'rhl-quote-data');
      controller = new win.AbortController();
      var timeout = win.setTimeout(function () { controller.abort(); }, 8000);
      win.fetch(endpoint.href, { credentials: 'same-origin', signal: controller.signal, headers: { Accept: 'application/json' } }).then(function (r) {
        if (!r.ok) throw new Error('Product lookup unavailable');
        return r.json();
      }).then(function (data) {
        if (!cleared) render(enrich(request, data));
      }).catch(function () {
        if (!cleared) render(request, 'Your product link and selected options are included. Our team will confirm the details.');
      }).finally(function () { win.clearTimeout(timeout); });
    }
    initUpload(win, form);
    form.addEventListener('submit', function () {
      if (current) {
        // Keep quantities separate from the product snapshot so changes in the form win.
        var qty = form.querySelector('#q-quantity');
        if (qty) current.quantity = quantity(qty.value);
      }
    });
    if (form.querySelector('[data-quote-success]') && request) {
      try { win.sessionStorage.removeItem(PREFIX + request.token); } catch (_) {}
    }
  }
  function initUpload(win, form) {
    var wrapper = form.querySelector('[data-quote-upload]');
    if (!wrapper || wrapper.dataset.uploadInitialized) return;
    var endpoint = wrapper.dataset.uploadEndpoint || '';
    if (endpoint !== 'https://rhl-inquiry-files.yiosi-group-8666.chatgpt.site') return;
    wrapper.dataset.uploadInitialized = 'true';
    var input = wrapper.querySelector('input[type="file"]');
    var list = wrapper.querySelector('[data-quote-file-list]');
    var empty = wrapper.querySelector('[data-quote-file-empty]');
    var status = wrapper.querySelector('[data-quote-upload-status]');
    var output = form.querySelector('#q-uploaded-files');
    var files = [];
    var tokenPromise = null;
    var tokenUses = 0;
    var tokenExpires = 0;
    function sync() {
      empty.hidden = files.length > 0;
      output.value = files.filter(function (file) { return file.url; }).map(function (file) { return file.name + ': ' + file.url; }).join('\n');
      list.replaceChildren();
      files.forEach(function (file) {
        var li = win.document.createElement('li');
        var label = win.document.createElement('span');
        label.textContent = file.name + ' — ' + (file.pending ? 'Uploading…' : file.url ? 'Ready to send' : 'Upload failed');
        var remove = win.document.createElement('button');
        remove.type = 'button'; remove.textContent = 'Remove';
        remove.addEventListener('click', function () {
          file.controller.abort(); files = files.filter(function (item) { return item !== file; });
          status.textContent = ''; sync();
        });
        li.append(label, remove); list.append(li);
      });
      if (files.length && files.every(function (file) { return file.url && !file.pending; })) status.textContent = 'Files ready. Submit your enquiry to send them to us.';
    }
    function uploadToken() {
      if (!tokenPromise || tokenUses >= 3 || Date.now() > tokenExpires) {
        tokenUses = 0; tokenExpires = Date.now() + 9 * 60 * 1000;
        tokenPromise = win.fetch(endpoint + '/api/upload-session', { method: 'POST', credentials: 'omit', signal: win.AbortSignal.timeout(20000) }).then(function (response) {
          return response.json().then(function (data) { if (!response.ok || !data.token) throw new Error(data.error || 'Upload unavailable.'); return data.token; });
        });
      }
      tokenUses++;
      return tokenPromise;
    }
    input.addEventListener('change', function () {
      status.textContent = '';
      Array.from(input.files || []).forEach(function (selected) {
        if (files.length >= 3) { status.textContent = 'Please choose up to 3 files.'; return; }
        if (!/\.(jpe?g|png|webp|pdf)$/i.test(selected.name) || selected.size > 20 * 1024 * 1024 || !selected.size || selected.name.length > 160) {
          status.textContent = 'Choose JPG, PNG, WebP or PDF files, up to 20 MB each.'; return;
        }
        var file = { name: selected.name, pending: true, url: '', controller: new win.AbortController() };
        files.push(file);
        var timer = win.setTimeout(function () { file.controller.abort(); }, 180000);
        uploadToken().then(function (token) {
          if (file.controller.signal.aborted) throw new Error('Upload cancelled.');
          return win.fetch(endpoint + '/api/uploads', {
            method: 'POST', credentials: 'omit', body: selected, signal: file.controller.signal,
            headers: { 'Content-Type': selected.type || 'application/octet-stream', 'X-Upload-Name': encodeURIComponent(selected.name), 'X-Upload-Token': token }
          });
        }).then(function (response) {
          return response.json().then(function (data) { if (!response.ok) throw new Error(data.error || 'Upload failed.'); return data; });
        }).then(function (data) {
          var url = new URL(data.url);
          if (url.origin !== endpoint || !/^\/api\/files\/[a-f0-9]{64}$/.test(url.pathname)) throw new Error('Invalid file link.');
          file.name = data.name; file.url = url.href;
        }).catch(function (error) {
          if (files.includes(file)) status.textContent = (error.name === 'AbortError' ? 'Upload timed out.' : error.message) + ' Remove the file to retry or continue without it.';
          tokenPromise = null;
        }).finally(function () { win.clearTimeout(timer); file.pending = false; sync(); });
      });
      input.value = ''; sync();
    });
    form.addEventListener('submit', function (event) {
      if (files.some(function (file) { return file.pending || !file.url; })) {
        event.preventDefault();
        status.textContent = 'Please wait for uploads to finish, or remove failed files before submitting.';
        status.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    });
  }

  function init(win) {
    win.document.querySelectorAll('[data-rhl-quote-product]').forEach(function (node) { initProduct(win, node); });
    var form = win.document.getElementById('rhl-quote-form');
    if (form) initForm(win, form);
    win.document.addEventListener('shopify:section:load', function () { win.document.querySelectorAll('[data-rhl-quote-product]').forEach(function (node) { initProduct(win, node); }); });
  }
  return { init: init, initForm: initForm, initProduct: initProduct, readSelection: readSelection, quoteUrl: quoteUrl, readRequest: readRequest, enrich: enrich, imageUrl: imageUrl, productUrl: productUrl, quantity: quantity, normalizeCart: normalizeCart, readCartSnapshot: readCartSnapshot };
});
